<template>
  <button
    type="button"
    class="amazonpay-btn"
    :class="[hasErrors ? 'amazonpay-btn--disabled' : '']"
    :disabled="hasErrors || isLoading"
    @click.prevent="$emit('btnclick', $event)"
  >
    <span v-if="isLoading" class="text-gray-600">
      <slot name="loading">...loading</slot>
    </span>
    <img v-else :src="logo" alt="Amazon Pay" class="amazonpay-btn__logo" />
  </button>
</template>

<script>
import logo from '@/assets/amazon-pay-logo.svg'

export default {
  name: 'AmazonPayButton',

  props: {
    isLoading: Boolean,
    hasErrors: Boolean
  },

  data() {
    return { logo }
  }
}
</script>

<style scoped>
/* official Amazon Pay button colors, shape aligned with .btn */
.amazonpay-btn {
  @apply w-full flex items-center justify-center px-5 py-3 text-base leading-6 font-medium rounded-md transition duration-150 ease-in-out focus:outline-none focus:ring;
  background-color: #ffd814;
  border: 1px solid #fcd200;
}

.amazonpay-btn:hover:not(:disabled) {
  background-color: #f7ca00;
}

.amazonpay-btn--disabled,
.amazonpay-btn:disabled {
  @apply bg-gray-300 border-transparent cursor-not-allowed;
}

.amazonpay-btn--disabled .amazonpay-btn__logo,
.amazonpay-btn:disabled .amazonpay-btn__logo {
  filter: grayscale(1);
  opacity: 0.5;
}

.amazonpay-btn__logo {
  height: 1.5rem;
  /* the smile hangs below the wordmark in the SVG — nudge down so the text is optically centered */
  transform: translateY(8%);
}
</style>
